// ── LOW-POWER DEVICE DETECTION ──
// Suppress non-essential animations on devices with ≤2 CPU cores or ≤2 GB RAM.
// The data-low-power attribute on html lets CSS disable will-change, transforms,
// and scroll-reveal without affecting functionality.
(function () {
  var cores = Number(navigator.hardwareConcurrency);
  var ram   = Number(navigator.deviceMemory);
  if ((cores > 0 && cores <= 2) || (ram > 0 && ram <= 2)) {
    document.documentElement.setAttribute('data-low-power', '');
  }
})();

// ── THEME TOGGLE (light / dark mode) ──
(function () {
  var html = document.documentElement;
  var KEY  = 'glc-theme';

  function isLight() { return html.classList.contains('light-mode'); }

  /* Sync all toggle button labels + aria-labels to current state */
  function syncUI(light) {
    document.querySelectorAll('.js-theme-label').forEach(function (el) {
      el.textContent = light ? 'Light' : 'Dark';
    });
    document.querySelectorAll('.js-theme-toggle').forEach(function (btn) {
      btn.setAttribute('aria-label', light ? 'Switch to dark mode' : 'Switch to light mode');
    });
  }

  /* Run on load so labels reflect any preference restored by the anti-FOUC script */
  syncUI(isLight());

  /* Delegated handler — works for any .js-theme-toggle present or added later */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-theme-toggle');
    if (!btn) return;

    /* Activate transition layer */
    html.classList.add('is-theme-switching');

    var nowLight = html.classList.toggle('light-mode');
    localStorage.setItem(KEY, nowLight ? 'light' : 'dark');
    syncUI(nowLight);


    /* Reconnect shopify-account so it re-reads the new color-scheme */
    var saEl = document.querySelector('shopify-account.glc-account-overlay');
    if (saEl) {
      var saP = saEl.parentNode, saS = saEl.nextSibling;
      saP.removeChild(saEl);
      requestAnimationFrame(function () { saP.insertBefore(saEl, saS); });
    }

    /* Spin the icon of the clicked button */
    btn.classList.add('is-spinning');
    btn.addEventListener('transitionend', function handler() {
      btn.classList.remove('is-spinning');
      btn.removeEventListener('transitionend', handler);
    }, { once: true });

    /* Remove transition layer after animation completes */
    setTimeout(function () { html.classList.remove('is-theme-switching'); }, 340);
  });
})();

// ── SCROLL LOCK ──
// Pin the body so it physically cannot scroll while a drawer is open. This is
// event-independent (works on every browser) unlike body{overflow:hidden} (which
// doesn't stop touch scrolling) or touchmove preventDefault (unreliable). The
// scroll position is saved and restored on unlock; scrollbar width is padded so
// the desktop layout doesn't shift. Reference-counted for safe nesting.
(function () {
  var lockY = 0, depth = 0;
  window.__lockScroll = function () {
    if (depth++ > 0) return;
    lockY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    var b = document.body.style;
    b.position = 'fixed';
    b.top = -lockY + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
    if (sbw > 0) b.paddingRight = sbw + 'px';
  };
  window.__unlockScroll = function () {
    if (depth > 0 && --depth > 0) return;
    depth = 0;
    var b = document.body.style;
    b.position = b.top = b.left = b.right = b.width = b.paddingRight = '';
    window.scrollTo(0, lockY);
  };
})();

// ── MEDIA GALLERY (images, video, external video, 3D) ──
// Exposed so variant selection can activate a variant's media too.
function showProductMedia(mediaId) {
  var gallery = document.getElementById('product-media-gallery');
  if (!gallery || mediaId == null) return;
  var target = gallery.querySelector('.product-media[data-media-id="' + mediaId + '"]');
  if (!target) return;
  gallery.querySelectorAll('.product-media').forEach(function (m) {
    m.classList.toggle('is-active', m === target);
    if (m !== target) {
      // pause any playing HTML5 video / YouTube-Vimeo iframe when switching away
      var v = m.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
      var f = m.querySelector('iframe'); if (f) { f.src = f.src; }
    }
  });
  gallery.querySelectorAll('.product-images__thumb').forEach(function (t) {
    t.classList.toggle('active', t.getAttribute('data-media-id') === String(mediaId));
  });
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('#product-media-gallery .product-images__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () { showProductMedia(this.getAttribute('data-media-id')); });
  });

  // ── VARIANT SELECTION ──
  const optionBtns = document.querySelectorAll('.product-option__btn');
  const variantIdInput = document.getElementById('variant-id');

  // ── QUANTITY RULES (stock + per-order add-to-cart limit) ──
  function clampQty(value) {
    const i = document.getElementById('quantity-input');
    if (!i) return;
    const min  = parseInt(i.min, 10) || 1;
    const step = parseInt(i.step, 10) || 1;
    const max  = (i.max !== '' && i.max != null) ? parseInt(i.max, 10) : Infinity;
    if (isNaN(value)) value = min;
    value = Math.max(min, Math.min(max, value));
    let snapped = min + Math.round((value - min) / step) * step;   // snap to increment
    if (snapped > max) snapped -= step;
    i.value = Math.max(min, snapped);
  }
  function applyQuantityRules(variantId) {
    const i = document.getElementById('quantity-input');
    if (!i) return;
    const r = (window.__quantityRules || {})[String(variantId)] || { min: 1, increment: 1, max: null };
    i.min = r.min || 1;
    i.step = r.increment || 1;
    if (r.max != null) { i.max = r.max; } else { i.removeAttribute('max'); }
    clampQty(parseInt(i.value, 10));
  }

  if (optionBtns.length) {
    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const name = this.dataset.optionName;
        document.querySelectorAll(`[data-option-name="${name}"]`).forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        updateVariant();
      });
    });
  }

  function updateVariant() {
    const selected = {};
    document.querySelectorAll('.product-option__btn.active').forEach(function (btn) {
      selected[btn.dataset.optionName] = btn.dataset.optionValue;
    });

    const variants = window.__productVariants || [];
    const match = variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return selected[window.__productOptions[i]] === opt;
      });
    });

    if (match && variantIdInput) {
      variantIdInput.value = match.id;
      applyQuantityRules(match.id);
      const priceEl = document.getElementById('product-price');
      if (priceEl) {
        priceEl.innerHTML = '<span class="currency">£</span>' + (match.price / 100).toFixed(2);
      }
      const addBtn = document.getElementById('add-to-cart-btn');
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.style.opacity = match.available ? '1' : '0.4';
        addBtn.dataset.inventory = match.inventory_quantity != null ? match.inventory_quantity : '';
        addBtn.dataset.track     = match.inventory_management || '';
        const textSpan = addBtn.querySelector('.btn-add-to-cart__text');
        if (textSpan) textSpan.textContent = match.available ? ((window.theme.strings||{}).addToCart||'Add to cart') : ((window.theme.strings||{}).soldOut||'Sold out');
      }

      // Accelerated checkout + installments: only buyable variants
      const accel = document.getElementById('accelerated-checkout');
      if (accel) accel.hidden = !match.available;

      // Compare-at price
      const compareEl = document.getElementById('product-compare');
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.innerHTML = '£' + (match.compare_at_price / 100).toFixed(2);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      // Unit price
      const unitEl = document.getElementById('product-unit-price');
      if (unitEl && match.unit_price_measurement) {
        var ref = match.unit_price_measurement.reference_value;
        unitEl.textContent = '£' + (match.unit_price / 100).toFixed(2) + '/' + (ref !== 1 ? ref : '') + match.unit_price_measurement.reference_unit;
      }

      // Variant media swap — activate the variant's media in the gallery
      if (match.featured_media && match.featured_media.id) {
        showProductMedia(match.featured_media.id);
      } else if (match.featured_image && match.featured_image.src) {
        const mainImg = document.getElementById('main-product-img');
        if (mainImg) mainImg.src = match.featured_image.src;
      }

      // ── Update stock indicator ──
      const stockWrap = document.getElementById('product-stock-indicator-wrap');
      if (stockWrap) {
        var qty       = match.inventory_quantity;
        var tracked   = match.inventory_management === 'shopify';
        var threshold = window.__stockThreshold || 5;
        var show      = window.__showStockIndicator !== false;
        var lowOnly   = window.__stockLowOnly === true;

        if (!show || !tracked || !match.available) {
          stockWrap.innerHTML = '';
        } else if (qty <= threshold) {
          stockWrap.innerHTML =
            '<div class="stock-indicator stock-indicator--low">' +
              '<span class="stock-indicator__dot"></span>' +
              ' ' + ((window.theme.strings||{}).onlyLeft||'Only __N__ left!').replace('__N__', qty) +
            '</div>';
        } else if (!lowOnly) {
          stockWrap.innerHTML =
            '<div class="stock-indicator stock-indicator--ok">' +
              '<span class="stock-indicator__dot"></span>' +
              ' ' + ((window.theme.strings||{}).inStock||'__N__+ available').replace('__N__', threshold) +
            '</div>';
        } else {
          stockWrap.innerHTML = '';
        }
      }
    }
  }

  // ── AJAX ADD TO CART ──
  const productForm = document.getElementById('product-form');
  if (productForm) {
    // Quantity stepper — clamps to min/increment and the effective max (stock + order limit)
    const qtyInput = document.getElementById('quantity-input');
    if (qtyInput) {
      const stepOf = function () { return parseInt(qtyInput.step, 10) || 1; };
      productForm.querySelectorAll('[data-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () { clampQty((parseInt(qtyInput.value, 10) || 1) - stepOf()); });
      });
      productForm.querySelectorAll('[data-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () { clampQty((parseInt(qtyInput.value, 10) || 1) + stepOf()); });
      });
      qtyInput.addEventListener('change', function () { clampQty(parseInt(qtyInput.value, 10)); });
      applyQuantityRules(variantIdInput ? variantIdInput.value : null);
    }

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart-btn');
      const textSpan = btn ? btn.querySelector('.btn-add-to-cart__text') : null;
      const originalText = textSpan ? textSpan.textContent : ((window.theme.strings||{}).addToCart||'Add to cart');
      function setText(t) { if (textSpan) textSpan.textContent = t; }

      if (btn) { setText('Adding…'); btn.disabled = true; }

      var variantId = parseInt(document.getElementById('variant-id').value, 10);
      var quantity  = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      // Record the variant's compare-at so the drawer can show the saving immediately
      var pv = (window.__productVariants || []).find(function (v) { return v.id === variantId; });
      if (pv && pv.compare_at_price && pv.compare_at_price > pv.price) {
        window.__cartCompare = window.__cartCompare || {};
        window.__cartCompare[variantId] = pv.compare_at_price;
      }
      var stock     = btn ? parseInt(btn.dataset.inventory, 10) : NaN;
      var tracked   = btn ? btn.dataset.track === 'shopify' : false;

      function onBlocked() {
        if (btn) { setText((window.theme.strings||{}).cantAdd||"Can't add"); setTimeout(function () { setText(originalText); btn.disabled = false; }, 2000); }
        if (window.__openCartDrawer) window.__openCartDrawer("Can't add item due to availability.");
      }
      function onSuccess() {
        if (btn) { setText('✓ Added!'); setTimeout(function () { setText(originalText); btn.disabled = false; }, 1500); }
        if (window.__openCartDrawer) window.__openCartDrawer();
        else updateCartCount();
      }

      onBlocked._stock   = stock;
      onBlocked._tracked = tracked;
      doAdd(variantId, onSuccess, onBlocked, quantity);
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(function (cart) {
        const badge = document.getElementById('cart-count');
        if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
      });
  }
});


// ── CART PAGE ──
function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function setQtyBtns(disabled) {
  document.querySelectorAll('.qty-btn').forEach(function (b) { b.disabled = disabled; });
}

function cartChange(line, quantity) {
  setQtyBtns(true);

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
  .then(function (res) {
    if (!res.ok) {
      return res.json().then(function (err) {
        throw new Error(err.description || err.message || ('Cart update failed: ' + res.status));
      });
    }
    return res.json();
  })
  .then(function (cart) {
    // Item removed — reload to strip the row from the DOM
    if (quantity === 0) { window.location.href = '/cart'; return; }

    // If the cart carries any discount, re-render so discount rows + subtotal stay accurate
    if (cart.total_discount && cart.total_discount > 0) { window.location.reload(); return; }

    // Update each line item's price + qty display
    cart.items.forEach(function (item) {
      var linePrice = document.querySelector('.cart-item__line-price[data-key="' + item.key + '"]');
      if (linePrice) linePrice.textContent = formatMoney(item.final_line_price);

      // Keep the struck "was" price accurate on quantity change
      var wasEl = document.querySelector('.cart-item__line-price-was[data-key="' + item.key + '"]');
      if (wasEl) {
        var cu = (window.__cartCompare || {})[item.variant_id];
        if (item.original_line_price > item.final_line_price) wasEl.textContent = formatMoney(item.original_line_price);
        else if (cu) wasEl.textContent = formatMoney(cu * item.quantity);
      }

      var unitPrice = document.querySelector('.cart-item__unit-price[data-key="' + item.key + '"]');
      if (unitPrice) {
        unitPrice.style.display = item.quantity > 1 ? '' : 'none';
        if (item.quantity > 1) unitPrice.textContent = formatMoney(item.price) + ' each';
      }

      // Keep qty display in sync with server truth
      var qtyDisplay = document.querySelector('.qty-display[data-key="' + item.key + '"]');
      if (qtyDisplay) qtyDisplay.textContent = item.quantity;
    });

    // Update summary
    var subtotalEl  = document.getElementById('cart-subtotal');
    var totalEl     = document.getElementById('cart-total');
    var itemCountEl = document.getElementById('cart-item-count');
    if (subtotalEl)  subtotalEl.textContent  = formatMoney(cart.items_subtotal_price);
    if (totalEl)     totalEl.textContent     = formatMoney(cart.total_price);
    if (itemCountEl) itemCountEl.textContent = 'Subtotal (' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ')';

    // Header badge
    var badge = document.getElementById('cart-count');
    if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }

    setQtyBtns(false);
  })
  .catch(function (err) {
    console.error('[Cart]', err);
    setQtyBtns(false);
    // Revert optimistic display and show Shopify's reason to the customer
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      cart.items.forEach(function (item) {
        var d = document.querySelector('.qty-display[data-key="' + item.key + '"]');
        if (d) d.textContent = item.quantity;
      });
      // Show the error message briefly near the cart
      var msg = "Can't add item due to availability.";
      var notice = document.getElementById('cart-notice');
      if (!notice) {
        notice = document.createElement('div');
        notice.id = 'cart-notice';
        notice.style.cssText = 'color:#c0392b;font-size:0.85rem;margin:8px 0;text-align:center';
        var items = document.querySelector('.cart-items');
        if (items) items.prepend(notice);
      }
      notice.textContent = msg;
      setTimeout(function () { notice.textContent = ''; }, 4000);
    });
  });
}

document.addEventListener('click', function (e) {
  var plus   = e.target.closest('.qty-plus');
  var minus  = e.target.closest('.qty-minus');
  var remove = e.target.closest('.cart-item__remove');

  if (plus || minus) {
    var btn     = plus || minus;
    var line    = parseInt(btn.dataset.line, 10);
    var key     = btn.dataset.key;
    var display = document.querySelector('.qty-display[data-key="' + key + '"]');
    if (!display || !line) return;
    var current = parseInt(display.textContent.trim()) || 0;
    var newVal  = plus ? current + 1 : Math.max(0, current - 1);
    display.textContent = newVal;
    cartChange(line, newVal);
  } else if (remove) {
    cartChange(parseInt(remove.dataset.line, 10), 0);
  }
});

// ── SHARED: check cart qty before adding ──
function cartQtyForVariant(cart, variantId) {
  var qty = 0;
  cart.items.forEach(function (item) { if (item.variant_id === variantId) qty += item.quantity; });
  return qty;
}

function doAdd(variantId, onSuccess, onBlocked, quantity) {
  quantity = quantity || 1;
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var inCart = cartQtyForVariant(cart, variantId);
      // Will be populated by caller if inventory data is known
      if (typeof onBlocked._stock !== 'undefined' && onBlocked._tracked) {
        if (inCart + quantity > onBlocked._stock) { onBlocked(); return; }
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description); });
        return res.json();
      })
      .then(function () {
        onSuccess();
      });
    })
    .catch(onBlocked);
}

// ── QUICK-ADD (product cards on collection / featured-products / related) ──
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.product-card__add[data-variant-id]');
  if (!btn) return;

  var variantId  = parseInt(btn.dataset.variantId, 10);
  if (!variantId) return;

  // Record compare-at so the drawer can show the saving for quick-added items
  var qaCompare = parseInt(btn.dataset.compareAt, 10);
  if (qaCompare) { window.__cartCompare = window.__cartCompare || {}; window.__cartCompare[variantId] = qaCompare; }

  var stock    = parseInt(btn.dataset.inventory, 10);
  var tracked  = btn.dataset.track === 'shopify';
  var origText = btn.textContent.trim();

  btn.textContent = '…';
  btn.disabled = true;

  function onBlocked() {
    btn.textContent = (window.theme.strings||{}).cantAdd||"Can't add";
    setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
    if (window.__openCartDrawer) window.__openCartDrawer("Can't add item due to availability.");
  }

  function onSuccess() {
    btn.textContent = '✓';
    setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 1500);
    if (window.__openCartDrawer) window.__openCartDrawer();
  }

  onBlocked._stock   = stock;
  onBlocked._tracked = tracked;
  doAdd(variantId, onSuccess, onBlocked);
});

// ── CART DRAWER ──
(function () {
  var drawer  = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');
  var cartBtn  = document.getElementById('cart-icon-btn');
  var isOpen   = false;

  var pendingNotice = null;

  function openCartDrawer(notice) {
    if (!drawer) return;
    if (notice) pendingNotice = notice;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('active');
    window.__lockScroll();
    isOpen = true;
    fetchAndRender();
  }

  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('active');
    window.__unlockScroll();
    isOpen = false;
  }

  function fetchAndRender() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        var badge = document.getElementById('cart-count');
        if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
        if (pendingNotice) { showDrawerNotice(pendingNotice); pendingNotice = null; }
      })
      .catch(function () {
        var body = document.getElementById('cart-drawer-body');
        if (body) body.innerHTML = '<p style="padding:24px;color:var(--text-dim);text-align:center">Could not load cart. <a href="/cart" style="color:var(--red)">View cart</a></p>';
      });
  }

  function esc(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function imgUrl(url, w) {
    if (!url) return null;
    return url.indexOf('?') >= 0 ? url + '&width=' + w : url + '?width=' + w;
  }

  function unitMeasureHtml(item) {
    if (!item.unit_price_measurement) return '';
    var m = item.unit_price_measurement;
    return '<div class="drawer-item__unit">' + formatMoney(item.unit_price) + '/' +
      (m.reference_value !== 1 ? m.reference_value : '') + m.reference_unit + '</div>';
  }
  function lineDiscountsHtml(item) {
    if (!item.line_level_discount_allocations || !item.line_level_discount_allocations.length) return '';
    return '<div class="drawer-item__discounts">' + item.line_level_discount_allocations.map(function (a) {
      return '<span class="drawer-item__discount">' + esc(a.discount_application.title) + ' (−' + formatMoney(a.amount) + ')</span>';
    }).join('') + '</div>';
  }

  function renderCart(cart) {
    var body    = document.getElementById('cart-drawer-body');
    var footer  = document.getElementById('cart-drawer-footer');
    var actions = document.getElementById('cart-drawer-actions');
    var count   = document.getElementById('drawer-item-count');
    if (!body || !footer) return;

    if (count) count.textContent = cart.item_count;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="drawer-empty">' +
          '<svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<p>Your cart is empty</p>' +
          '<a href="/collections/all" class="btn-secondary">Browse Cards</a>' +
        '</div>';
      footer.innerHTML = '';
      if (actions) actions.hidden = true;
      return;
    }
    if (actions) actions.hidden = false;

    body.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var src  = item.featured_image && item.featured_image.url ? imgUrl(item.featured_image.url, 120) : null;
      var img  = src
        ? '<img src="' + src + '" alt="' + esc(item.title) + '" loading="lazy">'
        : '<span style="font-size:1.8rem;line-height:72px">🃏</span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="drawer-item__variant">' + esc(item.variant_title) + '</div>'
        : '';
      var sellingPlan = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
        ? '<div class="drawer-item__selling-plan">' + esc(item.selling_plan_allocation.selling_plan.name) + '</div>'
        : '';
      var compareUnit = (window.__cartCompare || {})[item.variant_id];
      var priceHtml;
      if (item.original_line_price > item.final_line_price) {
        priceHtml = '<div class="drawer-item__price"><span class="drawer-item__price-was">' + formatMoney(item.original_line_price) + '</span> <span class="drawer-item__price--sale">' + formatMoney(item.final_line_price) + '</span></div>';
      } else if (compareUnit && compareUnit > item.price) {
        priceHtml = '<div class="drawer-item__price"><span class="drawer-item__price-was">' + formatMoney(compareUnit * item.quantity) + '</span> <span class="drawer-item__price--sale">' + formatMoney(item.final_line_price) + '</span></div>';
      } else {
        priceHtml = '<div class="drawer-item__price">' + formatMoney(item.final_line_price) + '</div>';
      }
      // Per-unit price (shown when more than one), with struck compare-at if on sale
      var eachHtml = (item.quantity > 1)
        ? '<div class="drawer-item__each">' +
            ((compareUnit && compareUnit > item.price) ? '<span class="drawer-item__unit-was">' + formatMoney(compareUnit) + '</span> ' : '') +
            formatMoney(item.price) + ' each</div>'
        : '';
      return (
        '<div class="drawer-item" data-line="' + line + '">' +
          '<a href="' + item.url + '" class="drawer-item__img">' + img + '</a>' +
          '<div class="drawer-item__info">' +
            '<a href="' + item.url + '" class="drawer-item__name">' + esc(item.product_title) + '</a>' +
            variant + sellingPlan + unitMeasureHtml(item) +
            '<div class="drawer-item__bottom">' +
              '<div class="drawer-item__price-col">' + priceHtml + eachHtml + '</div>' +
              '<div class="drawer-item__qty">' +
                '<button class="drawer-qty-btn drawer-qty-minus" data-line="' + line + '" aria-label="Decrease">−</button>' +
                '<span class="drawer-qty-display">' + item.quantity + '</span>' +
                '<button class="drawer-qty-btn drawer-qty-plus" data-line="' + line + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<button class="drawer-item__remove" data-line="' + line + '" aria-label="' + ((window.theme.strings||{}).removeItem||'Remove item') + '">✕</button>' +
            '</div>' +
            lineDiscountsHtml(item) +
          '</div>' +
        '</div>'
      );
    }).join('');

    var discountRows = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<div class="drawer-subtotal drawer-subtotal--discount"><span>' + esc(d.title) + '</span><span>−' + formatMoney(d.total_allocated_amount) + '</span></div>';
    }).join('');

    footer.innerHTML =
      '<div class="drawer-note"><textarea id="drawer-note-input" class="drawer-note__input" rows="2" placeholder="Order notes" aria-label="Order notes">' + esc(cart.note || '') + '</textarea></div>' +
      '<div class="drawer-subtotal">' +
        '<span class="drawer-subtotal__label">Subtotal</span>' +
        '<span class="drawer-subtotal__price">' + formatMoney(cart.items_subtotal_price) + '</span>' +
      '</div>' +
      discountRows +
      (cart.total_discount > 0
        ? '<div class="drawer-subtotal drawer-subtotal--total"><span class="drawer-subtotal__label">Total</span><span class="drawer-subtotal__price">' + formatMoney(cart.total_price) + '</span></div>'
        : '') +
      (window.__taxesIncluded ? '<div class="drawer-tax-note">Tax included.</div>' : '');
  }

  function showDrawerNotice(msg) {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    var existing = document.getElementById('drawer-notice');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.id = 'drawer-notice';
    el.style.cssText = 'color:var(--red);font-size:0.8rem;padding:8px 0 4px;text-align:center';
    el.textContent = msg;
    body.prepend(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 4000);
  }

  function drawerChange(line, qty) {
    document.querySelectorAll('.drawer-qty-btn, .drawer-item__remove').forEach(function (b) { b.disabled = true; });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) { throw new Error(err.description || ''); });
      }
      return r.json();
    })
    .then(function (cart) {
      renderCart(cart);
      var badge = document.getElementById('cart-count');
      if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
    })
    .catch(function () {
      // Re-fetch the real cart state so the display stays accurate
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          var badge = document.getElementById('cart-count');
          if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
          showDrawerNotice("Can't add item due to availability.");
        });
    });
  }

  // Wire up open/close
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay)  overlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closeCartDrawer(); });

  // ── SWIPE-TO-CLOSE (mobile bottom sheet) ──
  // Start the drag from the handle pill OR the header row — both large, thumb-friendly.
  var SWIPE_CLOSE_THRESHOLD = 100; // px
  if (drawer && window.GLC && GLC.swipeDismiss) {
    GLC.swipeDismiss(
      [document.getElementById('cart-drawer-handle'), drawer.querySelector('.cart-drawer__header')],
      {
        direction: 'down',
        threshold: SWIPE_CLOSE_THRESHOLD,
        enabled: function () { return isOpen && window.innerWidth <= 600; },
        onStart: function () { drawer.classList.add('is-dragging'); },
        onDrag: function (delta) {
          drawer.style.transform = 'translateY(' + delta + 'px)';
          // Fade the overlay proportionally as the sheet is dragged away
          var progress = Math.min(delta / SWIPE_CLOSE_THRESHOLD, 1);
          if (overlay) overlay.style.opacity = String(1 - progress * 0.8);
        },
        onEnd: function () {
          // Clear inline styles — CSS transition snaps back or animates closed
          drawer.classList.remove('is-dragging');
          drawer.style.transform = '';
          if (overlay) overlay.style.opacity = '';
        },
        onDismiss: closeCartDrawer
      }
    );
  }

  // Delegated qty / remove inside the drawer
  document.addEventListener('click', function (e) {
    var plus   = e.target.closest('.drawer-qty-plus');
    var minus  = e.target.closest('.drawer-qty-minus');
    var remove = e.target.closest('.drawer-item__remove');
    if (!plus && !minus && !remove) return;

    var btn  = plus || minus || remove;
    var line = parseInt(btn.dataset.line, 10);
    if (!line) return;

    if (remove) { drawerChange(line, 0); return; }

    var display = btn.closest('.drawer-item__qty').querySelector('.drawer-qty-display');
    var current = parseInt(display.textContent) || 0;
    var newVal  = plus ? current + 1 : Math.max(0, current - 1);
    display.textContent = newVal;
    drawerChange(line, newVal);
  });

  // Save the drawer's order note
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'drawer-note-input') return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  });

  // Expose for AJAX add-to-cart
  window.__openCartDrawer = openCartDrawer;
})();

// ── COLLECTION / SEARCH FILTER DRAWER ──
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('filter-toggle');
  var sidebar = document.getElementById('collection-sidebar');
  if (!toggle || !sidebar) return;

  var isMobile = function () { return window.matchMedia('(max-width: 768px)').matches; };

  // Backdrop (only meaningful on mobile, where the sidebar is a bottom sheet)
  var backdrop = document.createElement('div');
  backdrop.className = 'filter-backdrop';
  document.body.appendChild(backdrop);

  // Drag handle + close button at the top of the sheet (shown on mobile via CSS)
  var handle = document.createElement('div');
  handle.className = 'collection-sidebar__handle';
  handle.innerHTML = '<div class="collection-sidebar__handle-bar"></div>';
  var closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'collection-sidebar__close';
  closeBtn.setAttribute('aria-label', 'Close filters');
  closeBtn.innerHTML = '✕';
  handle.appendChild(closeBtn);
  sidebar.insertBefore(handle, sidebar.firstChild);

  // Cap the sheet (and the backdrop) at the bottom of the sticky header so it
  // never covers the header. Header bottom is dynamic (the announcement bar may
  // be scrolled away), so measure it live.
  var siteTop = document.querySelector('.site-top');
  function fitToHeader() {
    var hb = siteTop ? Math.max(0, siteTop.getBoundingClientRect().bottom) : 0;
    sidebar.style.maxHeight = (window.innerHeight - hb) + 'px';
    backdrop.style.top = hb + 'px';
  }

  function open() {
    if (isMobile()) fitToHeader();
    sidebar.classList.add('open');
    backdrop.classList.add('active');
    toggle.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
    // NB: no `body { overflow:hidden }` here — it breaks the sticky header, which
    // we need visible above the sheet. The backdrop blocks background scroll, and
    // the sheet scrolls its own content (overscroll-behavior: contain).
  }
  function close() {
    sidebar.classList.remove('open');
    backdrop.classList.remove('active');
    toggle.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
    sidebar.style.maxHeight = '';
    backdrop.style.top = '';
  }

  toggle.addEventListener('click', function () {
    if (sidebar.classList.contains('open')) close(); else open();
  });
  backdrop.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // ── SWIPE-DOWN TO DISMISS — same gesture as the cart & nav sheets ──
  if (window.GLC && GLC.swipeDismiss) {
    var FILTER_SWIPE_THRESHOLD = 100; // px
    GLC.swipeDismiss(handle, {
      direction: 'down',
      threshold: FILTER_SWIPE_THRESHOLD,
      enabled: function () { return sidebar.classList.contains('open') && isMobile(); },
      onStart: function () { sidebar.classList.add('is-dragging'); },
      onDrag: function (delta) {
        sidebar.style.transform = 'translateY(' + delta + 'px)';
        var progress = Math.min(delta / FILTER_SWIPE_THRESHOLD, 1);
        backdrop.style.opacity = String(1 - progress * 0.8);
      },
      onEnd: function () {
        sidebar.classList.remove('is-dragging');
        sidebar.style.transform = '';
        backdrop.style.opacity = '';
      },
      onDismiss: close
    });
  }

  // Keep the cap in sync; if the viewport grows back to desktop, clear everything
  window.addEventListener('resize', function () {
    if (!isMobile()) {
      backdrop.classList.remove('active');
      sidebar.style.maxHeight = '';
      backdrop.style.top = '';
    } else if (sidebar.classList.contains('open')) {
      fitToHeader();
    }
  });
});

// ── MOBILE NAV ──
document.addEventListener('DOMContentLoaded', function () {
  var hamburger = document.getElementById('hamburger-btn');
  var mobileNav = document.getElementById('mobile-nav');
  var overlay = document.getElementById('mobile-nav-overlay');
  var closeBtn = document.getElementById('mobile-nav-close');

  function openNav() {
    mobileNav.classList.add('open');
    overlay.classList.add('active');
    hamburger.classList.add('active');
    hamburger.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    window.__lockScroll();
  }

  function closeNav() {
    mobileNav.classList.remove('open');
    overlay.classList.remove('active');
    hamburger.classList.remove('active');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    window.__unlockScroll();
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  // ── SWIPE-DOWN TO CLOSE — same gesture as the cart bottom sheet ──
  // Start the drag from the handle pill OR the header row.
  var NAV_SWIPE_THRESHOLD = 100; // px
  if (mobileNav && window.GLC && GLC.swipeDismiss) {
    GLC.swipeDismiss(
      [document.getElementById('mobile-nav-handle'), mobileNav.querySelector('.mobile-nav__header')],
      {
        direction: 'down',
        threshold: NAV_SWIPE_THRESHOLD,
        enabled: function () { return mobileNav.classList.contains('open'); },
        onStart: function () { mobileNav.classList.add('is-dragging'); },
        onDrag: function (delta) {
          mobileNav.style.transform = 'translateY(' + delta + 'px)';
          var progress = Math.min(delta / NAV_SWIPE_THRESHOLD, 1);
          if (overlay) overlay.style.opacity = String(1 - progress * 0.8);
        },
        onEnd: function () {
          mobileNav.classList.remove('is-dragging');
          mobileNav.style.transform = '';
          if (overlay) overlay.style.opacity = '';
        },
        onDismiss: closeNav
      }
    );
  }

  // Accordion dropdowns
  document.querySelectorAll('.mobile-nav__parent').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var children = this.nextElementSibling;
      var isOpen = children.classList.contains('open');

      // Close all
      document.querySelectorAll('.mobile-nav__children').forEach(function (c) {
        c.classList.remove('open');
      });
      document.querySelectorAll('.mobile-nav__parent').forEach(function (b) {
        b.classList.remove('open');
        b.setAttribute('aria-expanded', 'false');
      });

      // Open this one if it was closed
      if (!isOpen) {
        children.classList.add('open');
        this.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });
});
// ── PRODUCT RECOMMENDATIONS (related + complementary via Shopify's API) ──
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-recommendations[data-url]').forEach(function (el) {
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.product-recommendations__inner');
        if (inner) { el.innerHTML = inner.outerHTML; }
      })
      .catch(function () {});
  });
});

// ── SCROLL REVEAL — section-level fade-in on viewport entry ──
(function () {
  if (!('IntersectionObserver' in window)) return;
  var targets = document.querySelectorAll(
    '.section-padding, .trust-bar, .newsletter, .cta-banner, .store-intro, .testimonials, .video-section'
  );
  if (!targets.length) return;

  var CSS = '.scroll-reveal{opacity:0;transform:translateY(18px);transition:opacity 0.55s cubic-bezier(0.4,0,0.2,1),transform 0.55s cubic-bezier(0.4,0,0.2,1)}.scroll-reveal.is-visible{opacity:1;transform:none}@media(prefers-reduced-motion:reduce){.scroll-reveal,.scroll-reveal.is-visible{transition:none;opacity:1;transform:none}}';
  var s = document.createElement('style');
  s.textContent = CSS;
  document.head.appendChild(s);

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  targets.forEach(function (el) {
    // Skip if already in the viewport on load (above-fold content)
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      el.classList.add('scroll-reveal', 'is-visible');
    } else {
      el.classList.add('scroll-reveal');
      io.observe(el);
    }
  });
})();
